<template lang="pug">
.comment-form(:class="{'show-more': showMore}")
  form(@keyup.enter="submit", @submit.prevent.stop="submit")
    div.form-field(:class="{error: $v.form.comment.$error, 'error-required': !$v.form.comment.required}")
      label
        textarea(
          v-model="$v.form.comment.$model",
          placeholder="Comment",
          @focus="openMore",
          @keyup.enter.stop,
          ref="commentTextarea"
        )
    
    div.form-field(v-if="form.attachments")
      .attachments(v-for="attachment in form.attachments")
        .attachment
          img(:src="attachment.url")

    .comment-form-more
      div.form-field(v-if="isAdmin")
        .form-field-toggle
          label.toggle-switch
            .row.center
              .col
                input(type="checkbox", v-model="form.internal", :disabled="inReplyTo && internal")
                .toggle-switch-slider
                  .toggle-switch-knob
              .col
                div
                  span Internal Only

      .row.apart
        .col
          div.form-field
            form-upload(@uploaded="uploaded", size="full", endpoint="attachment", @click.stop)
              button.button.attachment-upload(type="button")
                span Add Image (Optional)
                font-awesome-icon.attachment-upload-icon(:icon="['fad','image']", style="--fa-primary-color: #00AC97;--fa-secondary-color: #00AC97;")
        .col
          div.form-field
            SubmitButton(label="Add Comment", :formState="formState")

</template>

<script>

import { required } from 'vuelidate/lib/validators'
import { form } from '@/mixins/form'
import FormUpload from '@/components/form/FormUpload'

export default {
  name: 'CommentForm',
  mixins: [form],
  components: {
    FormUpload,
  },
  props: {
    inReplyTo: {
      type: String,
      default: null
    },
    internal: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      showMore: false,
      formState: 'initial',
      form: {
        comment: '',
        attachments: null,
        internal: false
        //inReplyTo: this.activity._id
      }
    }
  },
  mounted () {
    if (this.inReplyTo) {
      this.form.inReplyTo = this.inReplyTo
      //console.log(this.$refs)
      this.$refs.commentTextarea.focus()
    }
    this.form.internal = this.internal
  },
  validations: {
    form: {
      comment: {
        required
      }
    }
  },
  computed: {
    isAdmin () {
      return this.$route.meta.member
    }    
  },
  methods: {
    openMore () {
      this.showMore = true
    },
    closeMore (e) {
      console.log(e)
      if (this.form.comment.length <= 0 && (!e.relatedTarget || !e.relatedTarget.classList.contains('attachment-upload'))) {
        this.$v.$reset()
        this.showMore = false
      }
    },
    uploaded (attachment) {
      this.$set(this.form, 'attachments', [attachment])
    },
    submit () {
      //console.log('submit comment')
      let data = Object.assign({}, this.form)
      if (data.attachments) {
        data.attachments = data.attachments.map(attachment => attachment._id)
      }

      if (this.__formInvalid()) return

      this.$emit('posted')

      this.formState = 'pending'
      //console.log(data)
      this.$store.dispatch('activities/postComment', data).then(() => {
        this.formState = 'success'
        this.$v.$reset()
        this.form = {
          comment: '',
          attachments: null
        }
        this.showMore = false
      }, errors => {
        this.formState = 'error'
        this.errors = errors
        //console.log(errors)
      })
    },
  }
}
</script>

<style scoped lang="stylus">
.comment-form
  margin-bottom $spacing-3
  .form-field
    margin-bottom $spacing

  .attachment-upload-icon
    height 16px

  .attachment
    border $border-default
    display inline-block
    padding 2px
    img
      max-height 100px

  .comment-form-more
    display none

  &.show-more
    .comment-form-more
      display block
</style>
